/**
 *
 * Asynchronously loads the component for LoadingSpinner
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
